import React, {Component} from "react"
import logo from "../../../images/neeuro_longtail_logo.png"
import logo_cn from "../../../images/neeuro_longtail_logo_CN.png"
import {injectIntl} from "react-intl"

class Header extends Component {
  render() {

    const intl = this.props.intl
    const format = intl.formatMessage
    const locale = format({id: 'system.current.locale'})

    return (
      <div className="text-center">
        <img src={_.startsWith(locale, 'zh')?logo_cn:logo} className="m-t-sm" style={{width: '100%'}}/>
        <div className="report-title">{this.props.text}</div>
      </div>
    )
  }
}

export default injectIntl(Header)



// WEBPACK FOOTER //
// ./src/routes/cogoland/report/Header.js